import { getAdaptiveCareLensKey } from './adaptiveQuickLogConfig';

const DEFAULT_MEDICATION_PROFILE_CONFIG = {
  addTitle: 'Add medication',
  editTitle: 'Edit medication',
  subtitle: 'Keep the current dose and schedule here.',
  medicationNameLabel: 'Medication name',
  medicationNamePlaceholder: 'e.g. Melatonin',
  startDateLabel: 'Start date',
  scheduleLabel: 'Schedule times',
  addScheduleLabel: 'Add another time',
  categoryLabel: 'Category',
  formLabel: 'Form',
  summaryFallback: 'Fill the row to create a quick medication summary.',
  saveAriaLabel: 'Save medication',
  cancelAriaLabel: 'Cancel medication',
};

const MEDICATION_PROFILE_CONFIG_BY_LENS = {
  hospice: {
    ...DEFAULT_MEDICATION_PROFILE_CONFIG,
    addTitle: 'Add comfort medication',
    editTitle: 'Edit comfort medication',
    subtitle: 'Keep scheduled and as-needed comfort meds here.',
    medicationNameLabel: 'Medication name',
    medicationNamePlaceholder: 'e.g. Morphine, Lorazepam, Senna',
    startDateLabel: 'Start date',
    scheduleLabel: 'Dose and timing',
    addScheduleLabel: 'Add another dose/time',
    categoryLabel: 'Medication type',
    summaryFallback: 'Add the dose and timing so caregivers can log it quickly.',
  },
};

export const getAdaptiveMedicationProfileConfig = (child = {}) => (
  MEDICATION_PROFILE_CONFIG_BY_LENS[getAdaptiveCareLensKey(child)] || DEFAULT_MEDICATION_PROFILE_CONFIG
);

